import type { ProductEntity, ProductsQueryItemModel } from '../model/types'

import { propOr } from 'lodash/fp'

import { useMainSourceProperty } from '@/shared/hooks/data'
import { useStore } from '@/shared/lib/datasheet/store'

import { getRowId } from './utils'

export type PriceManagerController = {
	initPrice: FieldState<null | number>
	finalPrice: FieldState<null | number>
}
export type FieldState<T> = {
	isChanged: boolean
	value: T
	localValue: T
	originalValue: T
}

function useFieldState<T>(
	id: string,
	field: string,
	originalValue: T
): FieldState<T> {
	const localValue = useStore(
		(state) => state.localData[id as string]?.[field] as T
	)
	const isChanged =
		localValue !== undefined &&
		localValue !== null &&
		localValue != originalValue

	return {
		isChanged,
		value: isChanged ? localValue : originalValue,
		localValue,
		originalValue,
	}
}
export function usePriceManager({
	content,
}: {
	content: ProductEntity | ProductsQueryItemModel
}): PriceManagerController {
	const sourceProp = useMainSourceProperty()
	const INIT_FIELD = sourceProp
	const FINAL_FIELD = sourceProp === 'esp' ? 'final_esp' : 'final_price'
	const id = getRowId(content)
	const initPrice = useFieldState<null | number>(
		id,
		INIT_FIELD,
		propOr(0, ['fields', INIT_FIELD], content)
	)
	const finalPrice = useFieldState<null | number>(
		id,
		FINAL_FIELD,
		propOr(0, ['fields', FINAL_FIELD], content)
	)

	return {
		initPrice,
		finalPrice,
	}
}
